
    import {onMounted, reactive, toRefs, computed, ref} from "vue";
    import EditorComponent from '@/components/editor/Editor.vue'
    import ApiMember from "@/request/apis/api_member";
    import {message} from "ant-design-vue/es";
    import PageUtil from "@/utils/page_util";
    import UploadUtil from "@/utils/upload_util";
    import {baseUrl} from "@/utils/config";
    import apiMember from "@/request/apis/api_member";
    interface IState {
        list:any,
        searches:any,
        total:any,
        formState:any,
        type:any
    }

    export default ({
        name: 'ArticleList',
        components: {EditorComponent},
        setup() {
            const state: IState = reactive({
                list:[],
                searches:{
                    page:PageUtil.pageNo,
                    limit:PageUtil.pageSize,
                    name:'',
                    type:0
                },
                total:0,
                title:'',
                visible:false,
                formState:{
                    id:'',
                    name:'',
                    image:'',
                    remark:'',
                    sort:''
                },
                type:''
            })

            const columns = [
                {
                    title: 'ID',
                    dataIndex: 'id',
                    key: 'id',
                    align:'center'
                },
                {
                    title: '商家名称',
                    dataIndex: 'shop_name',
                    key: 'shop_name',
                    align:'center'
                },
                {
                    title: '店铺logo',
                    dataIndex: 'shop_logo',
                    key: 'shop_logo',
                    align:'center'
                },
                {
                    title: '店铺类型',
                    key: 'shop_type_desc',
                    dataIndex: 'shop_type_desc',
                    align:'center'
                },
                {
                    title: '商品名称',
                    key: 'goods_name',
                    dataIndex: 'goods_name',
                    align:'center'
                },
                {
                    title: '商品图片',
                    key: 'goods_image',
                    dataIndex: 'goods_image',
                    align:'center'
                },
                { 
                    title: '评价',
                    key: 'goods_comment_desc',
                    dataIndex: 'goods_comment_desc',
                    align:'center'
                },
                {
                    title: '评价图片',
                    key: 'comment_image',
                    dataIndex: 'comment_image',
                    align:'center'
                },
                {
                    title: '评价人',
                    key: 'user',
                    dataIndex: 'user',
                    align:'center'
                },
                {
                    title: '评价人sn',
                    key: 'sn',
                    dataIndex: 'sn',
                    align:'center'
                },
                {
                    title: '创建时间',
                    key: 'create_time',
                    dataIndex: 'create_time',
                    align:'center'
                },
                {
                    title: '状态',
                    key: 'status_desc',
                    dataIndex: 'status_desc',
                    align:'center'
                },
                {
                    title: '操作',
                    key: 'action',
                    width: 150
                },
            ];

            const pagination = computed(() => ({
                total: state.total,
                current: state.searches.page,
                pageSize: state.searches.limit,
                showTotal: (total: any) => `共${total}条数据`,
                defaultPageSize: 10,
                // pageSizeOptions: ['5', '10', '15', '20'], // 可不设置使用默认
                showSizeChanger: true, // 是否启用pageSize选择
                showQuickJumper: true, // 是否显示跳转窗
            }));

            const getList = async()=>{
                const params = {...state.searches}
                const res = await ApiMember.CommentLists(params)
                if(res.error_code == 0){
                    const data:any = res.data
                    state.list = data.lists
                    state.total = data.count
                }else{
                    message.error(res.msg)
                }
            }

            const handleTableChange = (pages: any) => {
                state.searches.limit = pages.pageSize
                state.searches.page = pages.current
                getList()
            };

            const formRef = ref();
            const uploadHeaders = UploadUtil.uploadHeaders()
            let uploadAction = baseUrl + '/admin/upload/image'
            let uploadFormData = {cid: 10}
            const handleChange = ({file}: any) => {
                if (file.status === 'done' && file.response) {
                    const res = file.response
                    if (res && res.error_code === 0) {
                        const data = res.data
                        state.formState.image = data.uri
                    }
                }
            }

            const onDel = async (item) => {
                const params = {id:item.id}
                const res = await apiMember.CategoryDel(params)
                if (res) {
                    message.destroy()
                    if (res.error_code === 0) {
                        message.success(res.msg)
                        await getList()
                        return
                    }
                    message.error(res.msg)
                }
            }
            const onStatus = async (item) => {
                const params = {id:item.id}
                const res = await apiMember.CommentChangeStatus(params)
                if (res) {
                    message.destroy()
                    if (res.error_code === 0) {
                        message.success(res.msg)
                        await getList()
                        return
                    }
                    message.error(res.msg)
                }
            }
            const onSearch = () => {
                state.searches.page = 1
                state.searches.limit = PageUtil.pageSize
                getList()
            }
            const onReset = () => {
                state.searches.page = 1
                state.searches.limit = PageUtil.pageSize
                state.searches.name = ''
                getList()
            }
            onMounted(() => {
                getList()
            })

            return {
                ...toRefs(state),
                getList,
                uploadHeaders,
                uploadAction,
                onSearch,
                onReset,
                onStatus,
                uploadFormData,
                pagination,
                columns,
                onDel,
                formRef,
                handleChange,

                handleTableChange
            }
        }
    })
